// extracted by mini-css-extract-plugin
export default {"loadingcontainer":"Loading_loadingcontainer__Xyz4B","spinner":"Loading_spinner__wPgVn","spin":"Loading_spin__d4N4X","loadinglogo":"Loading_loadinglogo__n8UWc"};